import { useEffect } from 'react';
import useLatest from 'use-latest';

var castArray = function castArray(value) {
  return Array.isArray(value) ? value : [value];
};

// Fixing inconsistencies from older browsers
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
var aliases = new Map([['Win', 'Meta'], ['Scroll', 'ScrollLock'], ['Spacebar', ' '], ['Down', 'ArrowDown'], ['Left', 'ArrowLeft'], ['Right', 'ArrowRight'], ['Up', 'ArrowUp'], ['Del', 'Delete'], ['Crsel', 'CrSel'], ['Exsel', 'ExSel'], ['Apps', 'ContextMenu'], ['Esc', 'Escape'], ['Decimal', '.'], ['Multiply', '*'], ['Add', '+'], ['Subtract', '-'], ['Divide', '/']]);

var shimKeyboardEvent = function shimKeyboardEvent(event) {
  if (aliases.has(event.key)) {
    var key = aliases.get(event.key);
    Object.defineProperty(event, 'key', {
      get: function get() {
        return key;
      }
    });
  }
};

var useKeypress = function useKeypress(keys, handler) {
  var keysRef = useLatest(keys);
  var handerRef = useLatest(handler);
  useEffect(function () {
    var handleKeydown = function handleKeydown(event) {
      shimKeyboardEvent(event);

      if (castArray(keysRef.current).includes(event.key)) {
        handerRef.current(event);
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return function () {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, []);
};

export default useKeypress;
